import { render, staticRenderFns } from "./apinvfrm.vue?vue&type=template&id=33cd77c6"
import script from "./apinvfrm.vue?vue&type=script&lang=js"
export * from "./apinvfrm.vue?vue&type=script&lang=js"
import style0 from "./apinvfrm.vue?vue&type=style&index=0&id=33cd77c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports